var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownChevronBlackIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 13,
    viewBox: "0 0 21 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_210_4365)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4909 12.3006C10.273 12.3006 10.066 12.2575 9.8699 12.1711C9.68106 12.092 9.49948 11.9625 9.32516 11.7827L1.12141 3.48438C0.84539 3.20381 0.707447 2.8621 0.707447 2.45923C0.707447 2.20024 0.77281 1.95925 0.903534 1.73623C1.03426 1.51322 1.20856 1.33336 1.42643 1.19668C1.64431 1.06719 1.89132 1.00244 2.16734 1.00244C2.56673 1.00244 2.92268 1.15352 3.23493 1.45567L10.4909 8.8475L17.7468 1.45567C18.0519 1.15352 18.4078 1.00244 18.8145 1.00244C19.0832 1.00244 19.3266 1.06719 19.5445 1.19668C19.7696 1.33336 19.9476 1.51322 20.0783 1.73623C20.209 1.95925 20.2744 2.20024 20.2744 2.45923C20.2744 2.8621 20.1364 3.20381 19.8604 3.48438L11.6566 11.7827C11.4823 11.9553 11.3008 12.0848 11.1119 12.1711C10.9231 12.2575 10.7161 12.3006 10.4909 12.3006Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_210_4365"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 21,
    fill: "white",
    transform: "matrix(0 1 -1 0 21 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownChevronBlackIcon);
export default __webpack_public_path__ + "static/media/down-chevron-black-icon.175e97f27ee9b4436dd9ec096440ac9e.svg";
export { ForwardRef as ReactComponent };